import cn from 'classnames';
import React from 'react';

interface Props {
  family?: ProgressFamily;
  type: ProgressType | ProgressType[];
  labeled?: boolean;
  max?: number;
  value?: number;
}

type ProgressFamily = 'danger' | 'success';
type ProgressType = 'progress-fade' | 'flash' | 'loop';

const Progress = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { family, type, max, value, labeled } = props;
  const classNames = cn('progress', family, type, { labeled });

  return (
    <div ref={ref} className={classNames}>
      <progress max={max} value={value} />
      {labeled ? <span>{`${value}%`}</span> : null}
    </div>
  );
});

export default Progress;
